import { request } from './client';
import type {
  DailyPostStat,
  ThreadAccountCreateAiPostRequest,
  ThreadAccountPostResponse,
  ThreadPostCreateResponse,
  ThreadPostDeleteResponse,
  ThreadPostStatisticsResponse,
} from './types';

export function createAiPost(
  threadAccountId: number,
  payload: ThreadAccountCreateAiPostRequest
) {
  return request<ThreadPostCreateResponse>(
    `/api/thread-account-posts/create-ai-post/threadAccountId/${threadAccountId}`,
    { method: 'POST', body: payload }
  );
}

export function getPostsByThreadAccount(
  threadAccountId: number,
  options?: { includeInsights?: boolean }
) {
  const includeInsights = options?.includeInsights === true;
  const q = includeInsights ? '?includeInsights=true' : '';
  return request<ThreadAccountPostResponse[]>(
    `/api/thread-account-posts/thread-account/${threadAccountId}${q}`,
    { method: 'GET' }
  );
}

/** Threads에서 등록 해제(soft delete). DB 상태는 UNREGISTERED로 유지됩니다. */
export function deletePost(id: number) {
  return request<ThreadPostDeleteResponse>(
    `/api/thread-account-posts/id/${id}`,
    { method: 'DELETE' }
  );
}

/** 등록 해제된 글을 기존 본문 그대로 Threads에 다시 발행합니다. */
export function reregisterPost(id: number) {
  return request<ThreadAccountPostResponse>(
    `/api/thread-account-posts/id/${id}/reregister`,
    { method: 'POST' }
  );
}

/** 콘텐츠 보드에서 완전 삭제. (발행 상태면 Threads 삭제 후 DB 레코드 제거) */
export function removePost(id: number) {
  return request<ThreadPostDeleteResponse>(
    `/api/thread-account-posts/id/${id}/remove`,
    { method: 'DELETE' }
  );
}

export function getStatistics() {
  return request<ThreadPostStatisticsResponse>(
    `/api/thread-account-posts/statistics`,
    { method: 'GET' }
  );
}

export function getDailyStatistics(days = 14) {
  return request<DailyPostStat[]>(
    `/api/thread-account-posts/statistics/daily?days=${days}`,
    { method: 'GET' }
  );
}
